import Typewriter from 'typewriter-effect/dist/core';

export default {
    init() {
        let tapWritter = document.getElementById('tapWritter');

        let typewriter = new Typewriter(tapWritter, {
            loop: true,
        });
        
        typewriter.typeString('Professionnels Techniques ?')
            .pauseFor(200)
            .deleteAll(1)
            .typeString('Solutions adaptées ?')
            .pauseFor(200)
            .deleteChars(10)
            .typeString('innovantes ?')
            .deleteAll(1)
            .pauseFor(200)
            .typeString('Développements sur mesure ?')
            .pauseFor(200)
            .deleteAll(1)
            .start();
    },
    finalize() {
      // JavaScript to be fired on the sommaire page, after the init JS
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/sommaire.js